export default ({local}) => {
    return `<div class="map-modal">
                <div class="map-modal__header">
                    <h4 class="map-modal__header-title"></h4>
                    <span class="map-modal__close btn btn-fab" data-ripple-center="true">
                        <svg class="icon-svg icon-svg--outline">
                            <use class="times" xlink:href="#icon-times"></use>
                        </svg>
                    </span>
                </div>
                <div class="map-modal__body">
                    <div class="map-modal__content">
                        <h4 class="map-modal__title"></h4>
                        <p class="map-modal__detail display-6"></p>
                        <p class="map-modal__description small"></p>
                    </div>
                    <div class="map-modal__featured-image bg-img aspect-ratio--4x3"></div>
                </div>
                <div class="map-modal__action"><a class="map-modal__link btn btn-outline-gray-light btn-box" href="#">${ local.goToWebsiteBtn || 'Go to website'}</a></div>
            </div>`
}